<script setup>
  const { wide, full } = defineProps({ wide: Boolean, full: Boolean });
</script>

<!----------------------------------------------------------------------------->

<template>
  <Wrapper :wide="wide" :full="full">
    <div class="grid">
      <slot />
    </div>
  </Wrapper>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .grid {
    @include grid;
  }
</style>
